import { BadgeGroup } from "@at/design-system-elements";
import {
  TypeBeetle,
  TypePhantom,
  TypeSmart,
  ThemeSelectors,
} from "@at/design-system-foundation";
import styled, { createGlobalStyle } from "styled-components";

import { PrintStyleSheet } from "../../components/seller/advert-seller-details/location/location.styles";

export const ChatLauncher = createGlobalStyle`
    body iframe#launcher {
      z-index: 990 !important;

      @media screen and (max-width: 949px) {
          margin-bottom: 145px;
      }
    }

    body iframe[title^='Messaging window'] {
      z-index: 990 !important;
    }
`;

export const LeasingProductMobileHeading = styled.div`
  display: block;

  @media (min-width: 950px) {
    display: none;
  }
  ${PrintStyleSheet}
`;

export const LeasingProductGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  min-height: 200px;
  gap: ${({ theme }) => ThemeSelectors.getGroupFourSpacing(theme)};

  @media (min-width: 950px) {
    flex-wrap: nowrap;
    margin-bottom: ${({ theme }) =>
      ThemeSelectors.getDistinctOneSpacing(theme)};
    gap: ${({ theme }) => ThemeSelectors.getDistinctTwoSpacing(theme)};
  }

  @media print {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    gap: 35px;
    width: 100%;
  }
`;

export const LeasingProductGridLeft = styled.div`
  flex-basis: 100%;
  height: fit-content;
  width: 100%;

  @media (min-width: 950px) {
    position: sticky;
    top: 0;
    width: 60%;
  }

  @media print {
    width: 35%;
    position: relative;
  }
`;

export const LeasingProductGridRight = styled.aside`
  width: 100%;
  height: fit-content;
  top: 0;

  @media (min-width: 950px) {
    top: 0;
    height: fit-content;
    max-width: 423px;
  }

  @media print {
    width: 65%;
    top: unset;
  }
`;

export const LeasingProductDisclosure = styled(TypeSmart)`
  display: block;
  margin-top: ${({ theme }) => ThemeSelectors.getGroupTwoSpacing(theme)};
  margin-bottom: ${({ theme }) => ThemeSelectors.getGroupFiveSpacing(theme)};
  color: ${({ theme }) => ThemeSelectors.getCopyColor(theme)};
`;

export const LeasingProductDesktopHeading = styled.div`
  display: none;

  @media (min-width: 950px) {
    display: block;
  }

  @media print {
    display: block;

    ol > li > span {
      color: black;
      padding: 0 ${({ theme }) => ThemeSelectors.getGroupOneSpacing(theme)} 0 0;
    }
  }
`;

export const LeasingProductTitle = styled(TypePhantom)`
  margin-top: ${({ theme }) => ThemeSelectors.getGroupThreeSpacing(theme)};
`;

export const LeasingProductDerivative = styled(TypeBeetle).attrs({
  as: "span",
  weight: "400",
})`
  color: ${({ theme }) => ThemeSelectors.getCopyColor(theme)};
  display: block;
`;
export const LeasingOptionalFeatures = styled(BadgeGroup)`
  span {
    background-color: ${({ theme }) => ThemeSelectors.getLightGrey(theme)};
    color: ${({ theme }) => ThemeSelectors.getTitleColor(theme)};
  }
  margin-top: ${({ theme }) => ThemeSelectors.getGroupThreeSpacing(theme)};
  @media (max-width: 950px) {
    margin-bottom: ${({ theme }) => ThemeSelectors.getGroupTwoSpacing(theme)};
  }
`;

export const LeasingChargingTimes = styled.div`
  margin: ${({ theme }) => ThemeSelectors.getDistinctTwoSpacing(theme)} 0;
`;

export const LeasingBreadcrumbContainer = styled.div`
  margin-top: ${({ theme }) => ThemeSelectors.getGroupFourSpacing(theme)};
`;
